import { render, staticRenderFns } from "./tzfgList.vue?vue&type=template&id=6c023e3e&scoped=true&"
import script from "./tzfgList.vue?vue&type=script&lang=js&"
export * from "./tzfgList.vue?vue&type=script&lang=js&"
import style0 from "./tzfgList.vue?vue&type=style&index=0&id=6c023e3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c023e3e",
  null
  
)

export default component.exports